import { useCallback, useState } from "react";
import useCanAttachRulebook from "../attach/useCanAttachRulebook";
/** Attach-CTA gate + modal visibility for the public Rulebook profile header. */
export default function useRulebookProfileAttach() {
    const [stateIsAttachVisible, setStateIsAttachVisible] = useState(false);
    const { canAttach } = useCanAttachRulebook();
    const handleShowAttach = useCallback(() => {
        setStateIsAttachVisible(true);
    }, []);
    const handleCloseAttach = useCallback(() => {
        setStateIsAttachVisible(false);
    }, []);
    return { canAttach, isAttachVisible: stateIsAttachVisible, handleShowAttach, handleCloseAttach };
}
